import * as Tooltip from '@radix-ui/react-tooltip';
import { motion } from 'framer-motion';
import React, { ReactElement } from 'react';
import { Body, Headline, Text } from '../..';

export default function G2Callout(): ReactElement {
  return (
    <section
      className="mt-16 flex justify-center p-4 sm:mt-36"
      aria-labelledby="headline-g2">
      <div
        style={{
          maxWidth: 1200,
          width: 1200,
        }}>
        <div className="flex flex-col items-center justify-center text-center">
          <div className="flex flex-wrap items-center justify-center gap-x-6">
            <motion.img
              src="https://images.getstark.co/marketing/testimonials/DigitalAccessibilityTools_BestEstimatedROI_Roi.png?updatedAt=1743003703651"
              alt="G2 badge for Best ROI Spring 2025"
              className="min-w-[154px] max-w-[154px]"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{
                opacity: 1,
                scale: 1,
              }}
              transition={{
                type: 'spring',
                duration: 0.5,
                delay: 0,
              }}
              viewport={{ amount: 0.75 }}
            />

            <motion.img
              src="https://images.getstark.co/marketing/testimonials/DigitalAccessibilityTools_MomentumLeader_Leader.png?updatedAt=1743003703621"
              alt="G2 badge for Momentum Leader Spring 2025"
              className="min-w-[154px] max-w-[154px]"
              initial={{ opacity: 0, x: -20, scale: 0.8 }}
              whileInView={{
                opacity: 1,
                x: 0,
                scale: 1,
              }}
              transition={{
                type: 'spring',
                duration: 0.5,
                delay: 0.15,
              }}
              viewport={{ amount: 0.75 }}
            />

            <Tooltip.Provider delayDuration={200}>
              <Tooltip.Root>
                <Tooltip.Trigger asChild>
                  <motion.img
                    src="https://images.getstark.co/marketing/testimonials/g2-users-love-us.png"
                    alt="G2 badge for Users Love Us"
                    className="min-w-[154px] max-w-[154px]"
                    initial={{ opacity: 0, x: -20, scale: 0.8 }}
                    whileInView={{
                      opacity: 1,
                      x: 0,
                      scale: 1,
                    }}
                    transition={{
                      type: 'spring',
                      duration: 0.5,
                      delay: 0.3,
                    }}
                    viewport={{ amount: 0.75 }}
                  />
                </Tooltip.Trigger>
                <Tooltip.Portal>
                  <Tooltip.Content
                    side="bottom"
                    className="data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade select-none rounded-lg border-2 border-base-purple-500 bg-purple-50 px-5 py-3 shadow-xl will-change-[transform,opacity] data-[state=delayed-open]:data-[side=bottom]:animate-navigation-fade-in data-[state=delayed-open]:data-[side=top]:animate-navigation-fade-in">
                    <div>
                      <svg
                        role="img"
                        width="180"
                        height="36"
                        viewBox="0 0 180 36"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <title>
                          Review with 5 stars showing 4.7 of them colored in
                          with yellow
                        </title>
                        <path
                          d="M12.8133 11.6187L13.3508 11.5481L13.585 11.0592L17.5491 2.78399C17.6323 2.61044 17.8076 2.5 18 2.5C18.1925 2.5 18.3678 2.61044 18.451 2.78399L22.4151 11.0592L22.6493 11.5481L23.1868 11.6187L32.3151 12.8173C32.5064 12.8425 32.6662 12.9754 32.7257 13.1589C32.7852 13.3424 32.7338 13.5438 32.5936 13.6764L25.9195 19.9874L25.5239 20.3614L25.6234 20.8967L27.2986 29.9086C27.3338 30.098 27.2571 30.2908 27.1014 30.4042C26.9457 30.5176 26.7387 30.5314 26.5692 30.4398L18.4756 26.0641L18 25.807L17.5245 26.0641L9.43086 30.4398L9.90644 31.3195L9.43085 30.4398C9.26141 30.5314 9.05441 30.5176 8.8987 30.4042C8.74299 30.2908 8.66628 30.098 8.70149 29.9086L10.3767 20.8967L10.4762 20.3614L10.0806 19.9874L3.40652 13.6764L2.72285 14.3994L3.40652 13.6764C3.26633 13.5438 3.21492 13.3424 3.27441 13.1589C3.3339 12.9754 3.49367 12.8425 3.68495 12.8173L12.8133 11.6187Z"
                          fill="#FEDB63"
                          stroke="#4D4D4D"
                          strokeWidth="2"
                        />
                        <path
                          d="M48.8133 11.6187L49.3508 11.5481L49.585 11.0592L53.5491 2.78399C53.6323 2.61044 53.8076 2.5 54 2.5C54.1925 2.5 54.3678 2.61044 54.451 2.78399L58.4151 11.0592L58.6493 11.5481L59.1868 11.6187L68.3151 12.8173C68.5064 12.8425 68.6662 12.9754 68.7257 13.1589C68.7852 13.3424 68.7338 13.5438 68.5936 13.6764L61.9195 19.9874L61.5239 20.3614L61.6234 20.8967L63.2986 29.9086C63.3338 30.098 63.2571 30.2908 63.1014 30.4042C62.9457 30.5176 62.7387 30.5314 62.5692 30.4398L54.4756 26.0641L54 25.807L53.5245 26.0641L45.4309 30.4398L45.9064 31.3195L45.4309 30.4398C45.2614 30.5314 45.0544 30.5176 44.8987 30.4042C44.743 30.2908 44.6663 30.098 44.7015 29.9086L46.3767 20.8967L46.4762 20.3614L46.0806 19.9874L39.4065 13.6764L38.7229 14.3994L39.4065 13.6764C39.2663 13.5438 39.2149 13.3424 39.2744 13.1589C39.3339 12.9754 39.4937 12.8425 39.685 12.8173L48.8133 11.6187Z"
                          fill="#FEDB63"
                          stroke="#4D4D4D"
                          strokeWidth="2"
                        />
                        <path
                          d="M84.8133 11.6187L85.3508 11.5481L85.585 11.0592L89.5491 2.78399C89.6323 2.61044 89.8076 2.5 90 2.5C90.1925 2.5 90.3678 2.61044 90.451 2.78399L94.4151 11.0592L94.6493 11.5481L95.1868 11.6187L104.315 12.8173C104.506 12.8425 104.666 12.9754 104.726 13.1589C104.785 13.3424 104.734 13.5438 104.594 13.6764L97.9195 19.9874L97.5239 20.3614L97.6234 20.8967L99.2986 29.9086C99.3338 30.098 99.2571 30.2908 99.1014 30.4042C98.9457 30.5176 98.7387 30.5314 98.5692 30.4398L90.4756 26.0641L90 25.807L89.5245 26.0641L81.4309 30.4398L81.9064 31.3195L81.4309 30.4398C81.2614 30.5314 81.0544 30.5176 80.8987 30.4042C80.743 30.2908 80.6663 30.098 80.7015 29.9086L82.3767 20.8967L82.4762 20.3614L82.0806 19.9874L75.4065 13.6764L74.7229 14.3994L75.4065 13.6764C75.2663 13.5438 75.2149 13.3424 75.2744 13.1589C75.3339 12.9754 75.4937 12.8425 75.685 12.8173L84.8133 11.6187Z"
                          fill="#FEDB63"
                          stroke="#4D4D4D"
                          strokeWidth="2"
                        />
                        <path
                          d="M120.813 11.6187L121.351 11.5481L121.585 11.0592L125.549 2.78399C125.632 2.61044 125.808 2.5 126 2.5C126.192 2.5 126.368 2.61044 126.451 2.78399L130.415 11.0592L130.649 11.5481L131.187 11.6187L140.315 12.8173C140.506 12.8425 140.666 12.9754 140.726 13.1589C140.785 13.3424 140.734 13.5438 140.594 13.6764L133.919 19.9874L133.524 20.3614L133.623 20.8967L135.299 29.9086C135.334 30.098 135.257 30.2908 135.101 30.4042C134.946 30.5176 134.739 30.5314 134.569 30.4398L126.476 26.0641L126 25.807L125.524 26.0641L117.431 30.4398L117.906 31.3195L117.431 30.4398C117.261 30.5314 117.054 30.5176 116.899 30.4042C116.743 30.2908 116.666 30.098 116.701 29.9086L118.377 20.8967L118.476 20.3614L118.081 19.9874L111.407 13.6764L110.723 14.3994L111.407 13.6764C111.266 13.5438 111.215 13.3424 111.274 13.1589C111.334 12.9754 111.494 12.8425 111.685 12.8173L120.813 11.6187Z"
                          fill="#FEDB63"
                          stroke="#4D4D4D"
                          strokeWidth="2"
                        />
                        <path
                          d="M157.5 12L162 4.5L166.5 10.5V27L162 25.5L153 30L154.5 19.5L148.5 13.5L157.5 12Z"
                          fill="#FEDB63"
                        />
                        <path
                          d="M162 3L166.315 12.0086L176.25 13.3131L168.983 20.1852L170.807 30L162 25.2386L153.193 30L155.017 20.1852L147.75 13.3131L157.685 12.0086L162 3Z"
                          stroke="#4D4D4D"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <Text
                        level="mono"
                        color="black"
                        className="mt-2 text-center !text-[14px] !text-[#4D4D4D]">
                        4.7 / 5 STARS ON G2
                      </Text>
                    </div>
                  </Tooltip.Content>
                </Tooltip.Portal>
              </Tooltip.Root>
            </Tooltip.Provider>
          </div>
          <Headline
            id="headline-g2"
            level="1"
            color="blue"
            className="mt-8 max-w-[800px]">
            Built to{' '}
            <span className="homepage-mark">deliver business value</span>, loved
            by the community.
          </Headline>
          <Body className="mt-6 max-w-[734px]">
            Stark is the only Continuous Accessibility platform that accelerates
            time-to-compliance from design and code to QA and PM, and helps
            companies of all sizes deliver highest quality experiences for all
            users.
          </Body>
          <G2Reviews />
        </div>
      </div>
    </section>
  );
}

const G2Reviews = () => {
  const reviews = [
    '“Stark revolutionized my Accessibility Practice.”',
    '“My #1 go-to accessibility tool for every project!”',
    '“A must have for accessibility checks.”',
    '“Accessible design made easy.”',
  ];

  const randomNumber = Math.floor(Math.random() * reviews.length);

  return (
    <section className="mt-8 flex justify-center p-4">
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-4 rounded-xl border-2 border-base-purple-500 bg-purple-50 p-6">
        <svg
          role="img"
          width="70"
          height="70"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="min-w-[70px]">
          <title>G2 Reviews Logo</title>
          <path
            d="M70 35C70 54.334 54.334 70 35 70C15.666 70 0 54.334 0 35C0 15.666 15.666 0 35 0C54.334 0 70 15.68 70 35Z"
            fill="#FF492C"
          />
          <path
            d="M50.29 29.266H41.246V28.846C41.246 27.306 41.554 26.032 42.17 25.038C42.786 24.03 43.85 23.148 45.39 22.364L46.09 22.014C47.336 21.384 47.658 20.838 47.658 20.194C47.658 19.424 46.986 18.864 45.908 18.864C44.62 18.864 43.654 19.536 42.982 20.894L41.246 19.158C41.624 18.346 42.24 17.702 43.052 17.184C43.878 16.666 44.788 16.414 45.782 16.414C47.028 16.414 48.106 16.736 48.988 17.408C49.898 18.08 50.346 19.004 50.346 20.166C50.346 22.028 49.296 23.162 47.336 24.17L46.23 24.73C45.054 25.318 44.48 25.85 44.312 26.788H50.29V29.266ZM49.492 32.122H39.594L34.652 40.69H44.55L49.506 49.258L54.448 40.69L49.492 32.122ZM35.506 46.416C29.206 46.416 24.082 41.292 24.082 34.992C24.082 28.692 29.206 23.568 35.506 23.568L39.426 15.378C38.152 15.126 36.85 15 35.506 15C24.46 15 15.5 23.96 15.5 34.992C15.5 46.038 24.446 54.998 35.506 54.998C39.902 54.998 43.976 53.57 47.28 51.162L42.94 43.658C40.952 45.366 38.348 46.416 35.506 46.416Z"
            fill="white"
          />
        </svg>

        <Headline level="3" className="text-center !text-[28px]" color="purple">
          {reviews[randomNumber]}
        </Headline>
      </div>
    </section>
  );
};
